import React, { useState, useEffect, useCallback } from 'react';
import '../Recursos/AdminPedidos.css';

const API = 'https://centrocomunicar.com/api-comunicar/endpoints/reclamaciones.php';

/* ── Icons ── */
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconEdit     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBook     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M4 19.5A2.5 2.5 0 016.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconMail     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUser     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconClock    = () => (<svg viewBox="0 0 24 24" fill="none" width="13" height="13"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M12 6v6l4 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconFilter   = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const ESTADO_CONFIG = {
  pendiente:   { label: 'Pendiente',    bg: '#fef3c7', color: '#92400e' },
  en_proceso:  { label: 'En proceso',   bg: '#dbeafe', color: '#1e40af' },
  resuelto:    { label: 'Resuelto',     bg: '#d1fae5', color: '#065f46' },
  cerrado:     { label: 'Cerrado',      bg: '#f3f4f6', color: '#374151' },
};

const TIPO_CONFIG = {
  reclamo: { label: 'Reclamo', bg: '#fee2e2', color: '#991b1b' },
  queja:   { label: 'Queja',   bg: '#fef3c7', color: '#92400e' },
};

export default function AdminReclamaciones() {
  const [lista,       setLista]       = useState([]);
  const [loading,     setLoading]     = useState(false);
  const [busqueda,    setBusqueda]    = useState('');
  const [filtroEstado,setFiltroEstado]= useState('todos');
  const [filtroTipo,  setFiltroTipo]  = useState('todos');
  const [modalItem,   setModalItem]   = useState(null);
  const [respuesta,   setRespuesta]   = useState('');
  const [nuevoEstado, setNuevoEstado] = useState('');
  const [guardando,   setGuardando]   = useState(false);
  const [toast,       setToast]       = useState(null);

  const showToast = (msg, tipo = 'ok') => {
    setToast({ msg, tipo });
    setTimeout(() => setToast(null), 3500);
  };

  const fetchLista = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(API + '?action=admin_lista');
      const j = await r.json();
      if (j.success) setLista(j.data || []);
      else showToast(j.message || 'Error cargando datos', 'error');
    } catch (e) {
      showToast('Error de conexion', 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchLista(); }, [fetchLista]);

  /* KPIs */
  const kpis = {
    total:      lista.length,
    pendiente:  lista.filter(r => r.estado === 'pendiente').length,
    en_proceso: lista.filter(r => r.estado === 'en_proceso').length,
    resuelto:   lista.filter(r => r.estado === 'resuelto').length,
  };

  /* Filtrado */
  const q = busqueda.toLowerCase();
  const filtrados = lista.filter(function(r) {
    var matchBus    = !q || r.codigo?.toLowerCase().includes(q) || r.nombres?.toLowerCase().includes(q) || r.apellidos?.toLowerCase().includes(q) || r.email?.toLowerCase().includes(q);
    var matchEstado = filtroEstado === 'todos' || r.estado === filtroEstado;
    var matchTipo   = filtroTipo   === 'todos' || r.tipo_reclamo === filtroTipo;
    return matchBus && matchEstado && matchTipo;
  });

  /* Abrir modal */
  function abrirModal(item) {
    setModalItem(item);
    setRespuesta(item.respuesta_admin || '');
    setNuevoEstado(item.estado);
  }

  /* Guardar respuesta */
  async function guardarRespuesta() {
    if (!respuesta.trim()) { showToast('Escribe una respuesta antes de guardar', 'error'); return; }
    setGuardando(true);
    try {
      var r = await fetch(API + '?action=admin_responder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id:       modalItem.id,
          estado:   nuevoEstado,
          respuesta: respuesta.trim(),
        }),
      });
      var j = await r.json();
      if (!j.success) throw new Error(j.message || 'Error al guardar');
      showToast('Respuesta enviada y estado actualizado');
      fetchLista();
      setModalItem(null);
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setGuardando(false);
    }
  }

  /* Solo actualizar estado sin respuesta */
  async function soloActualizarEstado() {
    setGuardando(true);
    try {
      var r = await fetch(API + '?action=admin_estado', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: modalItem.id, estado: nuevoEstado }),
      });
      var j = await r.json();
      if (!j.success) throw new Error(j.message || 'Error al actualizar');
      showToast('Estado actualizado');
      fetchLista();
      setModalItem(prev => ({ ...prev, estado: nuevoEstado }));
    } catch (err) {
      showToast(err.message, 'error');
    } finally {
      setGuardando(false);
    }
  }

  function formatFecha(f) {
    if (!f) return '—';
    try { return new Date(f).toLocaleDateString('es-PE', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' }); }
    catch(e) { return f; }
  }

  function diasDesde(f) {
    if (!f) return null;
    var d = Math.floor((Date.now() - new Date(f).getTime()) / 86400000);
    return d;
  }

  return (
    <div className="apd-page">

      {toast && (
        <div className={'apd-toast apd-toast--' + toast.tipo}>
          {toast.tipo === 'ok' ? <IconCheck/> : <IconClose/>} {toast.msg}
        </div>
      )}

      {/* KPIs */}
      <div className="apd-kpis">
        <div className="apd-kpi">
          <p>Total registrados</p>
          <strong>{kpis.total}</strong>
          <span>Todos los estados</span>
        </div>
        <div className="apd-kpi" style={{borderColor:'#fcd34d'}}>
          <p>Pendientes</p>
          <strong style={{color:'#92400e'}}>{kpis.pendiente}</strong>
          <span>Sin atender</span>
        </div>
        <div className="apd-kpi" style={{borderColor:'#93c5fd'}}>
          <p>En proceso</p>
          <strong style={{color:'#1e40af'}}>{kpis.en_proceso}</strong>
          <span>En atencion</span>
        </div>
        <div className="apd-kpi apd-kpi--verde">
          <p>Resueltos</p>
          <strong>{kpis.resuelto}</strong>
          <span>Completados</span>
        </div>
      </div>

      {/* Toolbar */}
      <div className="apd-toolbar">
        <div className="apd-search">
          <IconSearch/>
          <input
            type="text"
            placeholder="Buscar por codigo, nombre o email..."
            value={busqueda}
            onChange={function(e) { setBusqueda(e.target.value); }}
          />
          {busqueda && <button onClick={function() { setBusqueda(''); }}><IconClose/></button>}
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'.5rem'}}>
          <IconFilter/>
          <select
            value={filtroEstado}
            onChange={function(e) { setFiltroEstado(e.target.value); }}
            style={{padding:'.45rem .8rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.83rem',background:'#fff',cursor:'pointer'}}
          >
            <option value="todos">Todos los estados</option>
            <option value="pendiente">Pendiente</option>
            <option value="en_proceso">En proceso</option>
            <option value="resuelto">Resuelto</option>
            <option value="cerrado">Cerrado</option>
          </select>
          <select
            value={filtroTipo}
            onChange={function(e) { setFiltroTipo(e.target.value); }}
            style={{padding:'.45rem .8rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.83rem',background:'#fff',cursor:'pointer'}}
          >
            <option value="todos">Reclamos y quejas</option>
            <option value="reclamo">Solo reclamos</option>
            <option value="queja">Solo quejas</option>
          </select>
        </div>
        <button className="apd-btn-ghost" onClick={fetchLista}><IconRefresh/></button>
        <span className="apd-count">{filtrados.length} registros</span>
      </div>

      {/* Tabla */}
      <div className="apd-tabla-wrap">
        <table className="apd-tabla">
          <thead>
            <tr>
              <th>Codigo</th>
              <th>Tipo</th>
              <th>Consumidor</th>
              <th>Bien / Servicio</th>
              <th>Fecha</th>
              <th>Dias</th>
              <th>Estado</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="apd-loading"><span className="apd-spinner"/> Cargando...</td></tr>
            ) : filtrados.length === 0 ? (
              <tr><td colSpan="8" className="apd-empty">No hay registros con ese criterio</td></tr>
            ) : filtrados.map(function(r) {
              var est  = ESTADO_CONFIG[r.estado]  || ESTADO_CONFIG.pendiente;
              var tipo = TIPO_CONFIG[r.tipo_reclamo] || TIPO_CONFIG.reclamo;
              var dias = diasDesde(r.fecha_registro);
              var vencido = dias !== null && dias > 30 && r.estado !== 'resuelto' && r.estado !== 'cerrado';
              return (
                <tr key={r.id} className="apd-tr" style={vencido ? {background:'#fff5f5'} : {}}>
                  <td>
                    <div style={{display:'flex',alignItems:'center',gap:'.4rem'}}>
                      <IconBook/>
                      <span style={{fontWeight:700,fontSize:'.82rem',color:'#111'}}>{r.codigo}</span>
                    </div>
                  </td>
                  <td>
                    <span className="apd-estado" style={{background:tipo.bg,color:tipo.color}}>
                      {tipo.label}
                    </span>
                  </td>
                  <td>
                    <div className="apd-cliente">
                      <strong>{r.nombres} {r.apellidos}</strong>
                      <span>{r.email}</span>
                    </div>
                  </td>
                  <td>
                    <span style={{fontSize:'.82rem',color:'#5a6a63',maxWidth:180,display:'block',overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>
                      {r.descripcion_bien}
                    </span>
                  </td>
                  <td className="apd-fecha">
                    <div style={{display:'flex',alignItems:'center',gap:'.25rem'}}>
                      <IconClock/>
                      {formatFecha(r.fecha_registro)}
                    </div>
                  </td>
                  <td>
                    <span style={{
                      fontWeight:700, fontSize:'.82rem',
                      color: vencido ? '#dc2626' : dias > 20 ? '#d97706' : '#5a6a63',
                    }}>
                      {dias !== null ? dias + 'd' : '—'}
                      {vencido && ' ⚠'}
                    </span>
                  </td>
                  <td>
                    <span className="apd-estado" style={{background:est.bg,color:est.color}}>
                      {est.label}
                    </span>
                  </td>
                  <td>
                    <button className="apd-icon-btn" onClick={function() { abrirModal(r); }} title="Ver y responder">
                      <IconEdit/>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* ══ MODAL DETALLE + RESPUESTA ══ */}
      {modalItem && (
        <div className="apd-overlay" onClick={function() { setModalItem(null); }}>
          <div className="apd-modal" style={{maxWidth:640}} onClick={function(e) { e.stopPropagation(); }}>

            {/* Cabecera */}
            <div className="apd-modal__head">
              <div>
                <div style={{display:'flex',alignItems:'center',gap:'.6rem',marginBottom:'.25rem'}}>
                  <IconBook/>
                  <h2 style={{margin:0}}>{modalItem.codigo}</h2>
                  <span className="apd-estado" style={{
                    background: (TIPO_CONFIG[modalItem.tipo_reclamo]||TIPO_CONFIG.reclamo).bg,
                    color:      (TIPO_CONFIG[modalItem.tipo_reclamo]||TIPO_CONFIG.reclamo).color,
                    fontSize:'.72rem',
                  }}>
                    {(TIPO_CONFIG[modalItem.tipo_reclamo]||TIPO_CONFIG.reclamo).label}
                  </span>
                </div>
                <p style={{margin:0,fontSize:'.8rem',color:'#5a6a63'}}>
                  Registrado el {formatFecha(modalItem.fecha_registro)}
                </p>
              </div>
              <button className="apd-modal__close" onClick={function() { setModalItem(null); }}><IconClose/></button>
            </div>

            <div className="apd-modal__body" style={{maxHeight:'70vh',overflowY:'auto'}}>

              {/* Datos consumidor */}
              <div style={{background:'#f9fafb',borderRadius:12,padding:'1rem',marginBottom:'1rem',border:'1px solid rgba(130,216,179,.2)'}}>
                <p style={{fontSize:'.75rem',fontWeight:700,color:'#5a6a63',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.7rem'}}>
                  <IconUser/> Datos del consumidor
                </p>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'.5rem'}}>
                  {[
                    ['Nombre',    modalItem.nombres + ' ' + modalItem.apellidos],
                    ['Documento', modalItem.tipo_doc + ': ' + modalItem.num_doc],
                    ['Email',     modalItem.email],
                    ['Telefono',  modalItem.telefono || '—'],
                    ['Domicilio', modalItem.domicilio || '—'],
                    ['Tipo persona', modalItem.tipo_persona === 'juridica' ? 'Persona juridica' : 'Persona natural'],
                  ].map(function(item) {
                    return (
                      <div key={item[0]}>
                        <span style={{fontSize:'.68rem',fontWeight:700,color:'#9ca3af',textTransform:'uppercase',letterSpacing:'.06em',display:'block'}}>{item[0]}</span>
                        <span style={{fontSize:'.85rem',color:'#111',fontWeight:500}}>{item[1]}</span>
                      </div>
                    );
                  })}
                </div>
                {modalItem.menor_edad === '1' || modalItem.menor_edad === 1 ? (
                  <div style={{marginTop:'.6rem',background:'#fef3c7',borderRadius:8,padding:'.5rem .8rem',fontSize:'.8rem',color:'#92400e'}}>
                    Menor de edad — Apoderado: <strong>{modalItem.nombre_apoderado}</strong>
                  </div>
                ) : null}
              </div>

              {/* Bien/servicio */}
              <div style={{background:'#f9fafb',borderRadius:12,padding:'1rem',marginBottom:'1rem',border:'1px solid rgba(130,216,179,.2)'}}>
                <p style={{fontSize:'.75rem',fontWeight:700,color:'#5a6a63',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.7rem'}}>
                  Bien o servicio
                </p>
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'.5rem'}}>
                  {[
                    ['Tipo bien',   modalItem.tipo_bien === 'servicio' ? 'Servicio' : 'Producto'],
                    ['Descripcion', modalItem.descripcion_bien],
                    ['Monto',       modalItem.monto ? 'S/. ' + parseFloat(modalItem.monto).toFixed(2) : '—'],
                    ['Cod. pedido', modalItem.pedido_codigo || '—'],
                  ].map(function(item) {
                    return (
                      <div key={item[0]}>
                        <span style={{fontSize:'.68rem',fontWeight:700,color:'#9ca3af',textTransform:'uppercase',letterSpacing:'.06em',display:'block'}}>{item[0]}</span>
                        <span style={{fontSize:'.85rem',color:'#111',fontWeight:500}}>{item[1]}</span>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Detalle del reclamo */}
              <div style={{background:'#fff8f0',borderRadius:12,padding:'1rem',marginBottom:'1rem',border:'1px solid #fed7aa'}}>
                <p style={{fontSize:'.75rem',fontWeight:700,color:'#92400e',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.5rem'}}>
                  Detalle del {modalItem.tipo_reclamo}
                </p>
                <p style={{fontSize:'.88rem',color:'#111',lineHeight:1.7,margin:0,whiteSpace:'pre-wrap'}}>{modalItem.detalle}</p>
              </div>

              {/* Pedido del consumidor */}
              <div style={{background:'#f0fdf4',borderRadius:12,padding:'1rem',marginBottom:'1rem',border:'1px solid #bbf7d0'}}>
                <p style={{fontSize:'.75rem',fontWeight:700,color:'#065f46',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.5rem'}}>
                  Lo que solicita el consumidor
                </p>
                <p style={{fontSize:'.88rem',color:'#111',lineHeight:1.7,margin:0,whiteSpace:'pre-wrap'}}>{modalItem.pedido_consumidor}</p>
              </div>

              {/* Respuesta anterior si existe */}
              {modalItem.respuesta_admin && (
                <div style={{background:'#eff6ff',borderRadius:12,padding:'1rem',marginBottom:'1rem',border:'1px solid #bfdbfe'}}>
                  <p style={{fontSize:'.75rem',fontWeight:700,color:'#1e40af',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:'.5rem'}}>
                    Respuesta enviada el {formatFecha(modalItem.fecha_respuesta)}
                  </p>
                  <p style={{fontSize:'.88rem',color:'#111',lineHeight:1.7,margin:0,whiteSpace:'pre-wrap'}}>{modalItem.respuesta_admin}</p>
                </div>
              )}

              {/* Panel respuesta admin */}
              <div style={{background:'#f9fafb',borderRadius:12,padding:'1rem',border:'1.5px solid rgba(130,216,179,.25)'}}>
                <p style={{fontSize:'.78rem',fontWeight:700,color:'#111',marginBottom:'.8rem'}}>
                  <IconMail/> Responder al consumidor
                </p>

                {/* Cambiar estado */}
                <div style={{marginBottom:'.8rem'}}>
                  <label style={{fontSize:'.75rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>Estado del caso</label>
                  <select
                    value={nuevoEstado}
                    onChange={function(e) { setNuevoEstado(e.target.value); }}
                    style={{width:'100%',padding:'.6rem .8rem',borderRadius:8,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.85rem',background:'#fff'}}
                  >
                    <option value="pendiente">Pendiente</option>
                    <option value="en_proceso">En proceso</option>
                    <option value="resuelto">Resuelto</option>
                    <option value="cerrado">Cerrado</option>
                  </select>
                </div>

                {/* Textarea respuesta */}
                <div style={{marginBottom:'.8rem'}}>
                  <label style={{fontSize:'.75rem',fontWeight:600,color:'#5a6a63',display:'block',marginBottom:'.3rem'}}>
                    Respuesta al consumidor <span style={{color:'#dc2626'}}>*</span>
                    <span style={{fontWeight:400,marginLeft:'.4rem'}}>(se enviara por email)</span>
                  </label>
                  <textarea
                    rows={5}
                    placeholder={'Escribe aqui la respuesta formal al consumidor. Este texto sera enviado directamente a su correo electronico...'}
                    value={respuesta}
                    onChange={function(e) { setRespuesta(e.target.value); }}
                    style={{width:'100%',padding:'.7rem .9rem',borderRadius:10,border:'1.5px solid rgba(130,216,179,.3)',fontFamily:'inherit',fontSize:'.88rem',lineHeight:1.6,resize:'vertical',outline:'none'}}
                  />
                  <span style={{fontSize:'.72rem',color:'#9ca3af',display:'block',textAlign:'right'}}>{respuesta.length} caracteres</span>
                </div>

                {/* Acciones */}
                <div style={{display:'flex',gap:'.6rem',flexWrap:'wrap'}}>
                  <button
                    onClick={guardarRespuesta}
                    disabled={guardando}
                    style={{display:'flex',alignItems:'center',gap:'.4rem',background:'#111614',color:'#82D8B3',border:'none',borderRadius:100,padding:'.6rem 1.4rem',fontFamily:'inherit',fontWeight:700,fontSize:'.85rem',cursor:'pointer',transition:'background .2s'}}
                  >
                    {guardando
                      ? <><span className="apd-spinner"/> Enviando...</>
                      : <><IconMail/> Enviar respuesta y actualizar estado</>
                    }
                  </button>
                  <button
                    onClick={soloActualizarEstado}
                    disabled={guardando}
                    style={{display:'flex',alignItems:'center',gap:'.4rem',background:'transparent',color:'#5a6a63',border:'1.5px solid rgba(130,216,179,.3)',borderRadius:100,padding:'.6rem 1.2rem',fontFamily:'inherit',fontWeight:600,fontSize:'.85rem',cursor:'pointer'}}
                  >
                    <IconCheck/> Solo cambiar estado
                  </button>
                </div>

                <p style={{fontSize:'.72rem',color:'#9ca3af',marginTop:'.6rem',lineHeight:1.5}}>
                  Al enviar la respuesta, el consumidor recibira un email con tu mensaje y el nuevo estado del caso. El plazo legal es de 30 dias habiles desde el registro.
                </p>
              </div>

            </div>

            <div className="apd-modal__foot">
              <button className="apd-btn-ghost" onClick={function() { setModalItem(null); }}>Cerrar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}